export enum NotificationTypeEnum {
  // user received notification against any admin sent notification or others from app
  USER_NOTIFICATION = "user_notification",
  // sent by admin from cp to users, this notification is for listing purpose in admin notifications list
  ADMIN_SENT_NOTIFICATION = "admin_sent_base_notification",
  LIVE_LECTURE_REMINDER = "live_lecture_reminder",
  SUBJECT_NOTE_CREATED = "subject_note_created",
  LECTURE_UPLOADED = "lecture_uploaded",
}
